import { render, staticRenderFns } from "./Callme.vue?vue&type=template&id=5d75d270&scoped=true"
import script from "./Callme.vue?vue&type=script&lang=js"
export * from "./Callme.vue?vue&type=script&lang=js"
import style0 from "./Callme.vue?vue&type=style&index=0&id=5d75d270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d75d270",
  null
  
)

export default component.exports